export default __webpack_public_path__ + "static/media/Meslite.29b42302.png";